import { render, staticRenderFns } from "./ClinicC.vue?vue&type=template&id=60f94265&scoped=true"
import script from "./ClinicC.vue?vue&type=script&lang=js"
export * from "./ClinicC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f94265",
  null
  
)

export default component.exports